export default (theme: Object) => ({
  root: {
    backgroundColor: theme.palette.backgrounds.main,
    minHeight: '100vh',
  },

  actionPanel: {
    width: '100%',
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 24px 80px',
  },
  datzLogo: {
    display: 'none',
  },
  content: {
    marginTop: '20px',
  },
});
